import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'corner-left-up-double',
  'IconCornerLeftUpDouble',
  [
    ['path', { d: 'M18 19h-6a3 3 0 0 1 -3 -3v-7', key: 'svg-0' }],
    ['path', { d: 'M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4', key: 'svg-1' }],
  ],
);
